export default "__VITE_ASSET__CW4QCgm8__"